// extracted by mini-css-extract-plugin
export default {"preview":"styles-module__preview__src-labstep-web-components-CustomIdentifierSet-Preview-_MiBAq"};